/**
 * Frontend Email Service Helper
 * Clean API for sending emails via backend
 */

import { post } from 'api'

/**
 * Send an email using emailType
 * @param {string} emailType - Type of email (e.g., 'user-approval', 'member-welcome')
 * @param {string} to - Recipient email address
 * @param {Object} data - Data for the email template
 * @param {Object} [options] - Optional settings
 * @param {string} [options.logo] - Logo URL
 * @param {Object} [options.cta] - Call to action { text, url }
 * @param {Array} [options.cc] - CC recipients [{ email }]
 * @param {Object} [options.headers] - Additional headers (e.g., Authorization)
 * @returns {Promise}
 */
export const sendEmail = async (emailType, to, data, options = {}) => {
    const { logo, cta, cc, headers } = options

    return post({
        subUrl: '/action/send-email',
        data: {
            emailType,
            to,
            data,
            logo,
            cta,
            cc
        },
        headers
    })
}

/**
 * Available email types:
 * - 'user-approval'      - User account approved
 * - 'user-disapproval'   - User account declined
 * - 'mentee-approval'    - Mentee approved (to parent)
 * - 'mentee-disapproval' - Mentee declined (to parent)
 * - 'member-welcome'     - Member signup welcome
 * - 'parent-welcome'     - Parent signup welcome
 * - 'event-notification' - Event reminder
 * - 'post-notification'  - New post notification
 */
